import { useCallback, useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'

// utils
import { 
  getDishMasterContract, 
  getTotalStakingPower, 
  getPokerCardMasterContract,
  getCarNFTMasterContract,
  getComboNFTCommonStakeERC721EarnBake3Contract,
  getCarNFTCommonStakeERC721EarnBake3Contract,
  getPokerCardCommonStakeERC721EarnBake3Contract,
  getCarNFTCommonStakeERC721EarnBake2Contract, 
  getPokerCardCommonStakeERC721EarnBake2Contract
} from '../../sushi/utils'

// hooks
import useYam from '../bakery/useYam'
import { NFTTYPE } from '../../constants/bakery/nft'
import { userBakeContractVersion } from '../../userType/userBakeContractVersion'

const useTotalStakingPower = (currentBlock: number, type?: string) => {
  const [totalStakingPower, setTotalStakingPower] = useState<BigNumber>()
  const bakeContractVersion = userBakeContractVersion(type)

  const sushi = useYam()
  let dishMasterContract = getDishMasterContract(sushi)
  if(bakeContractVersion === 'v2'){
    dishMasterContract = getComboNFTCommonStakeERC721EarnBake3Contract(sushi)
  }

  switch (type) {
    case NFTTYPE.POKER:
      dishMasterContract = getPokerCardMasterContract(sushi)
      break
    case NFTTYPE.POKER_V2:
      dishMasterContract = getPokerCardCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.POKER_V3:
      dishMasterContract = getPokerCardCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.CAR:
      dishMasterContract = getCarNFTMasterContract(sushi)
      break
    case NFTTYPE.CAR_V2:
      dishMasterContract = getCarNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.CAR_V3:
      dishMasterContract = getCarNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
  }

  const fetchTotalStakingPower = useCallback(async () => {
    const total = await getTotalStakingPower(dishMasterContract)
    setTotalStakingPower(new BigNumber(total).div(new BigNumber(10).pow(18)))
  }, [dishMasterContract])
  useEffect(() => {
    if (sushi && dishMasterContract) {
      fetchTotalStakingPower()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentBlock, sushi, dishMasterContract])

  return totalStakingPower
}

export default useTotalStakingPower
